import React from 'react';
import './TeamSideSelection.css';
import { Side } from '../types';

interface TeamSideSelectionProps {
  teamName: string;
  onSelectSide: (side: Side) => void;
}

const TeamSideSelection: React.FC<TeamSideSelectionProps> = ({ teamName, onSelectSide }) => {
  return (
    <div className="team-side-selection">
      <h2>{teamName} - Choose your starting side:</h2>
      <div className="side-buttons">
        <button 
          className="side-button ct-side"
          onClick={() => onSelectSide('CT')}
        >
          Counter-Terrorist
        </button>
        <button 
          className="side-button t-side"
          onClick={() => onSelectSide('T')}
        >
          Terrorist
        </button>
      </div>
    </div>
  );
};

export default TeamSideSelection;